export default __webpack_public_path__ + "static/media/img-support-banner-new.b9cdf850.png";